var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"transition",staticClass:"trans-back"},[_c('img',{attrs:{"src":require("@/assets/images/tiktok_loading.gif"),"alt":"Image GIF","width":"100"}}),_c('p',[_vm._v("Let me think 🤔 ...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }